import { useState } from "react";
import { Controller } from "react-hook-form";
import { Box, Chip, FormHelperText, FormLabel } from "@material-ui/core";

import { makeKey } from "../../../../utils/helpers";
import { CampaignBriefSearch } from "../../../../pages/campaign-briefs/components/campaign-briefs-search/campaign-briefs-search.components";

import { SelectedItems } from "../../../common-attributes/components/selected-items/selected-items.component";

import { useFieldsStyles } from "../fields.styles";

import { CBSearchFieldProps } from "./cb-search-field.props";
import { ICampaignBriefBare } from "../../../../pages/campaign-briefs/components/campaign-briefs-search/campaign-briefs-search.props";

export const CBSearchField = (props: CBSearchFieldProps) => {
  const [shouldResetSearch, setShouldResetSearch] = useState(true);

  const commonClasses = useFieldsStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;
  const canEdit = Boolean(props.userPermissions?.canEdit) || Boolean(props.noAuthRequired);
  const multiple = props.multiple ?? true;

  const handleSelect = (brief: any, value: any[], onChange: (data: any[]) => void) => {
    let data: any[];

    if (multiple) {
      data = value.concat([brief]);
    } else {
      data = [brief];
    }

    onChange(data);
    setShouldResetSearch(!shouldResetSearch);
  };

  const handleRemove = (id: number, value: any[], onChange: (data: any[]) => void) => {
    const data = value.filter((brief) => id !== brief.id);
    onChange(data);
  };

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <label className={commonClasses.fieldWrapper}>
          <Box display="flex" justifyContent="space-between">
            <FormLabel component="h3" error={hasError} required={props.required}>
              {props.label}
            </FormLabel>
          </Box>
          <CampaignBriefSearch
            currentValue={renderProps.field.value}
            id={props.name}
            isDisabled={!canEdit}
            onSelect={(brief) =>
              handleSelect(brief, renderProps.field.value, renderProps.field.onChange)
            }
            reset={shouldResetSearch}
          />
          {renderProps.field.value && (
            <SelectedItems>
              {renderProps.field.value.map((brief: ICampaignBriefBare, index: number) => (
                <Chip
                  key={makeKey("brief", index)}
                  label={brief.name}
                  onDelete={() => {
                    handleRemove(brief.id, renderProps.field.value, renderProps.field.onChange);
                  }}
                />
              ))}
            </SelectedItems>
          )}

          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </label>
      )}
    />
  );
};
